import * as R from "ramda"

type Path = string | number | (string | number)[]
// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Input = any

const has = R.curry((fullPath: Path, obj: Input): boolean => {
  const pathArr: (string | number)[] = Array.isArray(fullPath)
    ? fullPath
    : String(fullPath).split(".")

  if (pathArr.length === 0) {
    return R.has(pathArr[0], obj)
  }

  const path = R.init(pathArr)
  const prop = R.last(pathArr)

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!path) {
    return false
  }

  const parent = R.path(path, obj)

  return parent && prop ? R.has(prop, parent) : false
})

export default has
